
import FetchData from '@ezviz/FetchData';
import { message } from "antd";
import Cookies from "js-cookie";
import util from './../../utils/utils';
import { publishProduct } from './product';
import { selectModal } from './appPannel';
import intl from 'react-intl-universal';

export const GET_DEVELOPMENT_INFO = "GET_DEVELOPMENT_INFO";
export const GET_DEVELOPMENT_PANNEL_STATUS = "GET_DEVELOPMENT_PANNEL_STATUS";
export const DEVELOPMENT_MODEL_STATUS = "DEVELOPMENT_MODEL_STATUS";
export const UPDATE_REGDEVELOPMENT_LOADING = "UPDATE_REGDEVELOPMENT_LOADING";
export const UPDATE_MINPROGRAM_ID = "UPDATE_MINPROGRAM_ID";
export const GET_PROGRAM_PANNEL_INFO = "GET_PROGRAM_PANNEL_INFO";
export const GET_IS_DEVELOPMENT = "GET_IS_DEVELOPMENT";
export const UPDATE_ACCOUNT_LIST = "UPDATE_ACCOUNT_LIST";
export const UPDATA_GREY_PUBLIC_MODEL_STATUS = "UPDATA_GREY_PUBLIC_MODEL_STATUS";
export const UPDATA_PUBLIC_MODEL_STATUS = "UPDATA_PUBLIC_MODEL_STATUS";
export const GET_PUBLIC_APP_LIST = "GET_PUBLIC_APP_LIST";
export const UPDATE_SELECTED_PUBLIC_APP_LIST = "UPDATE_SELECTED_PUBLIC_APP_LIST";
export const GET_PACK_STATUS = "GET_PACK_STATUS";
export const QUERY_PUBLISH_TIME = "QUERY_PUBLISH_TIME";
export const UPDATE_LOADING_STATUS = "UPDATE_LOADING_STATUS";


message.config({
  top: 300,
  maxCount: 3
});

export function updateAppPannelLoadingStatus(loading) {
  return (dispatch, getState) => {
    dispatch({
      type: UPDATE_LOADING_STATUS,
      loading
    });
  };
}

// 获取是否展示成为开发者面板或者成为开发者
export function updateDevelopmentPannelStatus(data) {
  return (dispatch, getState) => {
    dispatch({
      type: GET_DEVELOPMENT_PANNEL_STATUS,
      developmentPannlStatus: data
    });
  };
}

// 存储开发者信息
export function saveDevelopmentInfo(data) {
  return (dispatch, getState) => {
    dispatch({
      type: GET_DEVELOPMENT_INFO,
      developmentInfo: data
    });
  };
}

// 是否为开发者
export function setIsDevelopment(data) {
  return (dispatch, getState) => {
    dispatch({
      type: GET_IS_DEVELOPMENT,
      isDevelopmentStatus: data
    });
  };
}

// 弹出注册开发者面板
export function updateDevelopModelStatue(data) {
  return (dispatch, getState) => {
    dispatch({
      type: DEVELOPMENT_MODEL_STATUS,
      developModelStatus: data
    });
  };
}

// 注册成为开发者按钮状态
export function updateLoadingStatus(loading) {
  return (dispatch, getState) => {
    dispatch({
      type: UPDATE_REGDEVELOPMENT_LOADING,
      regDevelopmentLoading: loading
    });
  };
}
// '0ef8e4e7a75e4b28913353'
// 存储小程序id
export function getMinProgramId(id) {
  return (dispatch, getState) => {
    dispatch({
      type: UPDATE_MINPROGRAM_ID,
      minprogramId: id
    });
  };
}

// 存储小程序面板信息
export function saveProgramPannelInfo(data) {
  return (dispatch, getState) => {
    const { programPannelInfo } = getState().appDevelopPannel;
    const newData = Object.assign({}, programPannelInfo, data);

    dispatch({
      type: GET_PROGRAM_PANNEL_INFO,
      programPannelInfo: newData
    });
  };
}

// 面板测试账号
export function updateAccountList(data) {
  return (dispatch, getState) => {
    const { accountList } = getState().appDevelopPannel;
    const newData = Object.assign([], accountList, data);
    dispatch({
      type: UPDATE_ACCOUNT_LIST,
      accountList: newData
    });
  };
}

// 灰度发布测试账号添加弹窗
export function updateGeryPublicModelVisible(data) {
  return (dispatch, getState) => {
    dispatch({
      type: UPDATA_GREY_PUBLIC_MODEL_STATUS,
      greyPublicModelVisible: data
    });
  };
}

// 全量发布app选择弹窗
export function updatePublicModelVisible(data) {
  return (dispatch, getState) => {
    dispatch({
      type: UPDATA_PUBLIC_MODEL_STATUS,
      publicAppModalVisible: data
    });
  };
}

// 全量发布获取app列表
export function updatePublicAppList(data) {
  return (dispatch, getState) => {
    dispatch({
      type: GET_PUBLIC_APP_LIST,
      publicAppList: data
    });
  };
}

// 全量发布已选择的app列表
export function updateSelectedPublicAppList(data) {
  return (dispatch, getState) => {
    dispatch({
      type: UPDATE_SELECTED_PUBLIC_APP_LIST,
      publicSelectedAppList: data
    });
  };
}

// 获取打包状态
export function queryPackStatus(data) {
  return (dispatch, getState) => {
    dispatch({
      type: GET_PACK_STATUS,
      packStatus: data
    });
  };
}

// 获取发布时间
export function queryPublishHistory(data) {

  return (dispatch, getState) => {
    dispatch({
      type: QUERY_PUBLISH_TIME,
      publishTime: data
    });
  };
}

// ********接口请求*************

// 获取开发者信息
export function getDevelopmentInfo() {
  return (dispatch, getState) => {
    dispatch(updateAppPannelLoadingStatus(true));
    const fetchData = new FetchData(`/iot/config/api/iot/support/developer/info`, {
      method: "GET",
      // body: req,
      metaHandler: {
        403: () => { window.location.href = '/authrization/login'; return; }
      },
    });
    fetchData
      .then(data => {
        if (data.code == 200) {
          if (data.data) {
            const developmentInfo = data.data
            dispatch(saveDevelopmentInfo(developmentInfo));
            dispatch(setIsDevelopment(true))
          }
        } else if (data.code == 10035) {
          // 未查询到开发者信息
          dispatch(setIsDevelopment(false));
        }
        dispatch(updateAppPannelLoadingStatus(false));
      })
      .catch(e => {
        dispatch(updateAppPannelLoadingStatus(false))
        message.error(intl.get('commmon.operate.retry'));
      });
  };
}

// 注册成为开发者获取验证码
export function getVerificationCode(email, callback = () => { }) {
  return (dispatch, getState) => {
    const defaultParam = {
      email: email
    }
    const req = Object.assign({}, defaultParam);
    const fetchData = new FetchData(`/iot/config/api/iot/support/developer/getVerificationCode`, {
      method: "GET",
      body: req,
      metaHandler: {
        403: () => { window.location.href = '/authrization/login'; return; }
      },
    });
    fetchData
      .then(data => {
        callback(data)
        if (data.code == 200) {
          message.success(intl.get('home.product.developAppPanel.message.sendVericode'))
        } else if (data.code == 10001) {
          message.error(intl.get('home.product.developAppPanel.message.emailErr'))
        } else if (data.code == 10040) {
          message.error(intl.get('home.product.developAppPanel.message.hasBeenDeveloper'))
        } else if (data.code == 10041) {
          message.error(intl.get('home.product.developAppPanel.message.exited'))
        } else if (data.code == 50000) {
          message.error(intl.get('home.product.developAppPanel.message.sendErr'))
        }
        else if (data.code == -51) {
          message.error(intl.get('home.product.developAppPanel.message.vericodeErr'))
        } else {
          message.error(data.msg)
        }
      })
      .catch(e => {
        message.error(intl.get('commmon.operate.retry'));
      });
  };
}

// 注册成为开发者
export function regDevelopment(values) {
  return (dispatch, getState) => {
    const { productDetail } = getState().product;
    const { productId } = productDetail;
    const defaultParam = {
      productId: productId
    }
    const req = Object.assign({}, defaultParam, values);
    const fetchData = new FetchData(`/iot/config/api/iot/support/developer/regSubmit`, {
      method: "POST",
      body: req,
      metaHandler: {
        403: () => { window.location.href = '/authrization/login'; return; }
      },
    });
    fetchData
      .then(data => {
        if (data.code == 200) {
          // 成功注册成为开发者后将初始化小程序面板返回miniProgramId
          if (data.data.miniProgramId) {
            // 存储小程序id
            dispatch(getMinProgramId(data.data.miniProgramId));
            // config小程序面板
            dispatch(selectModal({ rnPanel: data.data.miniProgramId }))
            // 获取开发者信息
            dispatch(getDevelopmentInfo());
            // 获取小程序信息
            dispatch(queryMiniProgramInfo())
            // 显示小程序面板
            dispatch(updateDevelopModelStatue(false));
            // 获取打包状态
            dispatch(getPackageStatus());
          }
        } else if (data.code == -51) {
          message.error(message.error(intl.get('resetPwd.valid.mesage.failed')))
        } else {
          message.error(data.msg);
        }
      })

      .catch(e => {
        message.error(intl.get('commmon.operate.retry'));
      });
  };
}
// 直接成为开发者,私有云定制使用
export function registerDevelopment(values) {
  return (dispatch, getState) => {
    const { productDetail } = getState().product;
    const { productId } = productDetail;
    const defaultParam = {
      productId: productId
    }
    const req = Object.assign({}, defaultParam, values);
    const fetchData = new FetchData(`/iot/config/api/iot/support/developer/register`, {
      method: "POST",
      body: req,
      metaHandler: {
        403: () => { window.location.href = '/authrization/login'; return; }
      },
    });
    fetchData
      .then(data => {
        if (data.code == 200) {
          // 获取开发者信息
          dispatch(getDevelopmentInfo());
          // 成功注册成为开发者后将初始化小程序面板返回miniProgramId
          if (data.data.miniProgramId) {
            // 存储小程序id
            dispatch(getMinProgramId(data.data.miniProgramId));
            // config小程序面板
            dispatch(selectModal({ rnPanel: data.data.miniProgramId }))
            // 获取开发者信息
            dispatch(getDevelopmentInfo());
            // 获取小程序信息
            dispatch(queryMiniProgramInfo())
            // 显示小程序面板
            dispatch(updateDevelopModelStatue(false));
            // 获取打包状态
            dispatch(getPackageStatus());
          }
        } else if (data.code == -51) {
          message.error(intl.get('resetPwd.valid.mesage.failed'))
        } else {
          message.error(data.msg);
        }
      })

      .catch(e => {
        message.error(intl.get('commmon.operate.retry'));
      });
  };
}

// 重置Appsecret
export function retAppsecret() {
  return (dispatch, getState) => {

    const fetchData = new FetchData(`/iot/config/api/iot/support/developer/resetAppSecret`, {
      method: "POST",
      // body: req,
      metaHandler: {
        403: () => { window.location.href = '/authrization/login'; return; }
      },
    });
    fetchData
      .then(data => {
        if (data.code == 200) {
          if (data.data) {
            message.success(intl.get('home.product.appPanelEIB.developPanel.codePackagePublish.reset.success'));
            dispatch(getDevelopmentInfo())
          }
        } else {
          message.error(intl.get('home.product.appPanelEIB.developPanel.codePackagePublish.reset.error'));
        }
      })
      .catch(e => {
        message.error(intl.get('commmon.operate.retry'));
      });
  };
}

// 获取小程序面板信息
export function queryMiniProgramInfo() {
  return (dispatch, getState) => {
    const { minprogramId } = getState().appDevelopPannel;
    const defaultParam = {
      miniProgramId: minprogramId
    };
    const req = Object.assign({}, defaultParam);
    const fetchData = new FetchData(`/iot/config/api/iot/support/miniProgram/info/${req.miniProgramId}`, {
      method: "GET",
      body: req,
      metaHandler: {
        403: () => { window.location.href = '/authrization/login'; return; }
      },
    });
    fetchData
      .then(data => {
        if (data.code == 200) {
          if (data.data) {
            const programInfo = data.data;
            dispatch(saveProgramPannelInfo(programInfo))
          }
        }
      })
      .catch(e => {
        message.error(intl.get('commmon.operate.retry'));
      });
  };
}

// 修改小程序面板信息
export function updateProgramInfo() {
  return (dispatch, getState) => {
    const { minprogramId, programPannelInfo } = getState().appDevelopPannel;
    const { cnName, enName, logo } = programPannelInfo;
    if (!cnName || !enName) {
      message.warning('请填写必填项');
      return
    }
    const defaultParam = {
      // miniProgramId: minprogramId,
      cnName: cnName,
      enName: enName,
      logo: logo
    };
    const req = Object.assign({}, defaultParam);
    const fetchData = new FetchData(`/iot/config/api/iot/support/miniProgram/info/${minprogramId}`, {
      method: "PUT",
      body: req,
      metaHandler: {
        403: () => { window.location.href = '/authrization/login'; return; }
      },
    });
    fetchData
      .then(data => {
        if (data.code == 200) {
          message.success(intl.get('home.product.feature.saveSuccess'))
        } else if (data.code == 10001 || data.code == 60016) {
          message.error(data.msg)
        }
        else {
          message.error(intl.get('home.product.feature.saveFailed'))
        }
      })
      .catch(e => {
        message.error(intl.get('commmon.operate.retry'));
      });
  };
}

// 获取面板测试账号列表
export function getProgramAccountInfo() {
  return (dispatch, getState) => {
    const { minprogramId } = getState().appDevelopPannel;
    const defaultParam = {
      miniProgramId: minprogramId
    }
    const req = Object.assign({}, defaultParam);
    const fetchData = new FetchData(`/iot/config/api/iot/support/miniProgram/greyAccount/list`, {
      method: "GET",
      body: req,
      metaHandler: {
        403: () => { window.location.href = '/authrization/login'; return; }
      },
    });
    fetchData
      .then(data => {
        if (data.code == 200) {
          const list = data.data;
          dispatch(updateAccountList(list))
        }
      })
      .catch(e => {
        message.error(intl.get('commmon.operate.retry'));
      });
  };
}
// 提交小程序测试账号
export function putProgramAccountInfo(value, callback = () => { }) {
  return (dispatch, getState) => {
    const { minprogramId } = getState().appDevelopPannel;
    const defaultParam = {
      accounts: value,
      miniProgramId: minprogramId
    }
    const req = Object.assign({}, defaultParam);
    const fetchData = new FetchData(`/iot/config/api/iot/support/miniProgram/greyAccount`, {
      method: "PUT",
      body: req,
      metaHandler: {
        403: () => { window.location.href = '/authrization/login'; return; }
      },
    });
    fetchData
      .then(data => {
        callback(data);
        if (data.code == 200) {
          dispatch(getProgramAccountInfo())
        } else {
          message.error(data.msg);
        }
      })
      .catch(e => {
        message.error(intl.get('commmon.operate.retry'));
      });
  };
};

// 删除小程序测试账号
export function deleteProgramAccountInfo(value, callback = () => { }) {
  return (dispatch, getState) => {
    const { minprogramId } = getState().appDevelopPannel;
    const defaultParam = {
      account: value,
      miniProgramId: minprogramId
    }
    const req = Object.assign({}, defaultParam);
    const fetchData = new FetchData(`/iot/config/api/iot/support/miniProgram/greyAccount/delete`, {
      method: "POST",
      body: req,
      metaHandler: {
        403: () => { window.location.href = '/authrization/login'; return; }
      },
    });
    fetchData
      .then(data => {
        if (data.code == 200) {
          message.success(intl.get('commmon.operate.deleteSuccess'))
          callback(data)
          dispatch(getProgramAccountInfo())
        }
      })
      .catch(e => {
        message.error(intl.get('commmon.operate.retry'));
      });
  };
};

// 获取全量发布app列表
export function getPublicAppList() {
  return (dispatch, getState) => {
    const { minprogramId } = getState().appDevelopPannel;
    const defaultParam = {
      miniProgramId: minprogramId
    }
    const req = Object.assign({}, defaultParam);
    const fetchData = new FetchData(`/iot/config/api/iot/support/miniProgram/getApps`, {
      method: "GET",
      body: req,
      metaHandler: {
        403: () => { window.location.href = '/authrization/login'; return; }
      },
    });
    fetchData
      .then(data => {
        if (data.code == 200) {
          const list = data.data;
          if (list.selectable && list.selectable.length > 0) {
            dispatch(updatePublicAppList(list.selectable))
          } else {
            dispatch(updatePublicAppList([]))
          }
          if (list.selected && list.selected.length > 0) {
            dispatch(updateSelectedPublicAppList(list.selected))
          } else {
            dispatch(updateSelectedPublicAppList([]))
          }
        }
      })
      .catch(e => {
        message.error(intl.get('commmon.operate.retry'));
      });
  };
};

// 设置全量发布app
export function setPublicAppList(appIds) {
  return (dispatch, getState) => {
    const { minprogramId } = getState().appDevelopPannel;
    const defaultParam = {
      miniProgramId: minprogramId,
      appIds: appIds
    }
    const req = Object.assign({}, defaultParam);
    const fetchData = new FetchData(`/iot/config/api/iot/support/miniProgram/setApps`, {
      headers: {
        'Content-Type': 'application/x-www-form-urlencoded'
      },
      method: "POST",
      body: req,
      metaHandler: {
        403: () => { window.location.href = '/authrization/login'; return; }
      },
    });
    fetchData
      .then(data => {
        if (data.code == 200) {
          message.success(intl.get('home.appDevelopPannel.appSelectSuccess'));
          dispatch(updatePublicModelVisible(false))
        } else if (data.code == '10001') {
          message.error(data.msg);
        }
      })
      .catch(e => {
        message.error(intl.get('commmon.operate.retry'));
      });
  };
};

// 小程序发布
export function publishAppProgram(isGrey, callback = () => { }) {
  return (dispatch, getState) => {
    const { minprogramId } = getState().appDevelopPannel;
    const defaultParam = {
      miniProgramId: minprogramId,
      isGrey: isGrey
    }
    const req = Object.assign({}, defaultParam);
    const fetchData = new FetchData(`/iot/config/api/iot/support/miniProgram/publish`, {
      method: "POST",
      body: req,
      metaHandler: {
        403: () => { window.location.href = '/authrization/login'; return; }
      },
    });
    fetchData
      .then(data => {
        callback();
        if (data.code == 200) {
          message.success(intl.get('home.product.firmwareUpgradeDetail.releaseSuccess'));
          dispatch(updateGeryPublicModelVisible(false));
          dispatch(getPackageStatus())
        } else {
          message.error(data.msg)
        }
      })
      .catch(e => {
        message.error(intl.get('commmon.operate.retry'));
      });
  };
};

// 获取打包状态
export function getPackageStatus() {
  return (dispatch, getState) => {
    const { minprogramId } = getState().appDevelopPannel;
    const defaultParam = {
      miniProgramId: minprogramId,
    }
    const req = Object.assign({}, defaultParam);
    const fetchData = new FetchData(`/iot/config/api/iot/support/miniProgram/packageStatus`, {
      method: "GET",
      body: req,
      metaHandler: {
        403: () => { window.location.href = '/authrization/login'; return; }
      },
    });
    fetchData
      .then(data => {
        if (data.code == 200) {
          if (data.data && data.data.state === 1) {
            // 打包成功
            dispatch(queryPackStatus(4));
            // 获取发布记录
            dispatch(getPublishHistory())
            message.success(data.msg);
          } else if (data.data && data.data.state === 2) {
            // 打包失败/重新构建
            dispatch(queryPackStatus(3));
            message.error(data.msg);
          } else if (data.data && (data.data.state === 4 || data.data.state === 3)) {
            // 打包中
            dispatch(queryPackStatus(6));
            message.warning(data.msg);
          } else {
            // 打包失败/重新构建
            dispatch(queryPackStatus(3));
            message.error(data.msg);
          }
        } else if (data.code == '50016' || data.code == '60009') {
          // 没有查询到打包信息
          dispatch(queryPackStatus(1));
          message.warning(data.msg);
        } else if (data.code == '50010') {
          // 没有查询到小程序信息
          message.error(data.msg);
        }
      })
      .catch(e => {
        message.error(intl.get('commmon.operate.retry'));
      });
  };
};

// 获取发布记录
export function getPublishHistory() {
  return (dispatch, getState) => {
    const { minprogramId } = getState().appDevelopPannel;
    const defaultParam = {
      miniProgramId: minprogramId,
    }
    const req = Object.assign({}, defaultParam);
    const fetchData = new FetchData(`/iot/config/api/iot/support/miniProgram/publishHistory`, {
      method: "GET",
      body: req,
      metaHandler: {
        403: () => { window.location.href = '/authrization/login'; return; }
      },
    });
    fetchData
      .then(data => {
        if (data.code == 200) {
          if (data.data && data.data.publishTime) {
            dispatch(queryPackStatus(5));
            // 发布记录
            dispatch(queryPublishHistory(data.data))
          }
        } else {

        }
      })
      .catch(e => {
        message.error(intl.get('commmon.operate.retry'));
      });
  };
};
